"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = exports.ProductStatus = exports.StrictProductStatusAttributes = exports.ProductStatusAttributes = exports.ProductStatusKey = void 0;
const S = __importStar(require("@effect/schema/Schema"));
const productId_1 = require("./datatypes/productId");
const tenantId_1 = require("./datatypes/tenantId");
const NonePartialOrAll = S.Union(S.Literal('None'), S.Literal('Partial'), S.Literal('All'));
/* See ticket for design:
 * https://www.notion.so/fixtuur/Design-Data-Store-layer-for-Manifest-Service-84f233ed0f264db4b69ea2cb92117049?pvs=4
 */
exports.ProductStatusKey = S.Struct({
    tenant: S.String.pipe(S.fromBrand(tenantId_1.TenantId)),
    id: S.String,
});
const RequiredProductStatusAttributes = S.Struct({
    productId: S.String.pipe(S.fromBrand(productId_1.ProductId)),
});
const PartialProductStatusAttributes = S.partial(S.Struct({
    productData: S.Boolean,
    aspectProduct: S.Boolean,
    articleAssetModel: NonePartialOrAll,
    articleAssetParameters: NonePartialOrAll,
    arManifest: S.Boolean,
    arModel: S.Boolean,
    configurationSet: S.Boolean,
    particleService: S.Boolean,
    sirvSpinFile: S.String,
    sirvImageFiles: S.Array(S.String),
    created: S.String,
    modified: S.String,
}));
exports.ProductStatusAttributes = S.extend(RequiredProductStatusAttributes, PartialProductStatusAttributes);
exports.StrictProductStatusAttributes = S.required(exports.ProductStatusAttributes);
exports.ProductStatus = S.extend(exports.ProductStatusKey, exports.ProductStatusAttributes);
exports.parse = S.decodeUnknownEither(S.Data(exports.ProductStatus));
